/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ReviewAssetsHeader_storageInfo$ref: FragmentReference;
declare export opaque type ReviewAssetsHeader_storageInfo$fragmentType: ReviewAssetsHeader_storageInfo$ref;
export type ReviewAssetsHeader_storageInfo = {|
  +storage: ?{|
    +activeStorageReviewAssets: ?number,
    +archivedStorageReviewAssets: ?number,
  |},
  +$refType: ReviewAssetsHeader_storageInfo$ref,
|};
export type ReviewAssetsHeader_storageInfo$data = ReviewAssetsHeader_storageInfo;
export type ReviewAssetsHeader_storageInfo$key = {
  +$data?: ReviewAssetsHeader_storageInfo$data,
  +$fragmentRefs: ReviewAssetsHeader_storageInfo$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ReviewAssetsHeader_storageInfo",
  "type": "OrganizationNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "storage",
      "storageKey": null,
      "args": null,
      "concreteType": "StorageNode",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "activeStorageReviewAssets",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "archivedStorageReviewAssets",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '16c066359d0b7865a663a430ccd54dde';
module.exports = node;
